<div class="custom-dropdown-container" [class.disabled]="disabled" [class.has-error]="errorMessage">
  <!-- Label -->
  <label *ngIf="label" class="dropdown-label">
    {{ label }}
    <span *ngIf="required" class="required-mark">*</span>
  </label>

  <!-- Main Input Container -->
  <div class="dropdown-input-wrapper" [class.open]="isOpen" [class.disabled]="disabled" (click)="toggleDropdown()">
    
    <!-- Multi-select chips -->
    <div *ngIf="config.multiple && selectedItems.length > 0" class="chips-container">
      <span *ngFor="let item of selectedItems" class="chip">
        {{ getDisplayValue(item) }}
        <svg class="chip-remove" (click)="removeItem(item, $event)" width="14" height="14" viewBox="0 0 14 14">
          <path d="M14 1.41L12.59 0 7 5.59 1.41 0 0 1.41 5.59 7 0 12.59 1.41 14 7 8.41 12.59 14 14 12.59 8.41 7z" fill="currentColor"/>
        </svg>
      </span>
    </div>

    <!-- Search Input or Display Value -->
    <div class="dropdown-input-display">
      <span *ngIf="!config.multiple && selectedValue" class="display-text">{{ getDisplayValue(selectedValue) }}</span>
      <span *ngIf="!hasValue" class="placeholder-text">{{ config.placeholder || 'Select...' }}</span>
    </div>

    <!-- Dropdown Icons -->
    <div class="dropdown-icons">
      <!-- Clear Button -->
      <svg *ngIf="showClearButton" class="clear-icon" (click)="clearSelection($event)" width="16" height="16" viewBox="0 0 16 16">
        <path d="M16 1.6L14.4 0 8 6.4 1.6 0 0 1.6 6.4 8 0 14.4 1.6 16 8 9.6 14.4 16 16 14.4 9.6 8z" fill="currentColor"/>
      </svg>

      <!-- Dropdown Arrow -->
      <svg *ngIf="config.showDropdown !== false" class="dropdown-arrow" [class.open]="isOpen" width="12" height="8" viewBox="0 0 12 8">
        <path d="M1.41 0L6 4.59 10.59 0 12 1.41 6 7.41 0 1.41z" fill="currentColor"/>
      </svg>
    </div>
  </div>

  <!-- Dropdown Panel -->
  <div #dropdownPanel *ngIf="isOpen" class="dropdown-panel">
    <!-- Search Input Inside Panel -->
    <div class="panel-search-container">
      <svg class="search-icon" width="16" height="16" viewBox="0 0 16 16">
        <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z" fill="currentColor"/>
      </svg>
      <input
        #searchInput
        type="text"
        class="panel-search-input"
        [(ngModel)]="searchQuery"
        (input)="onSearchInput($event)"
        [placeholder]="'Search...'" 
        autocomplete="off">
    </div>

    <!-- Select All for Multi-Select -->
    <div *ngIf="config.multiple && !isLoading && filteredItems.length > 0" class="select-all-container">
      <div class="select-all-item" (click)="toggleSelectAll($event)">
        <svg *ngIf="!allItemsSelected()" class="checkbox-icon unchecked" width="18" height="18" viewBox="0 0 18 18">
          <rect x="1" y="1" width="16" height="16" rx="3" stroke="currentColor" stroke-width="2" fill="none"/>
        </svg>
        <svg *ngIf="allItemsSelected()" class="checkbox-icon checked" width="18" height="18" viewBox="0 0 18 18">
          <rect x="1" y="1" width="16" height="16" rx="3" fill="#8749bd"/>
          <path d="M13.854 5.646a.5.5 0 0 1 0 .708l-5 5a.5.5 0 0 1-.708 0l-2.5-2.5a.5.5 0 1 1 .708-.708L8.5 10.293l4.646-4.647a.5.5 0 0 1 .708 0z" fill="white" stroke="white" stroke-width="0.5"/>
        </svg>
        <span class="select-all-text">{{ allItemsSelected() ? 'Deselect All' : 'Select All' }}</span>
      </div>
    </div>

    <div class="dropdown-items-container">
      <!-- Loading State -->
      <div *ngIf="isLoading" class="dropdown-message">
        <svg width="24" height="24" viewBox="0 0 24 24" class="message-spinner">
          <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2" fill="none" stroke-dasharray="45" stroke-linecap="round">
            <animateTransform attributeName="transform" type="rotate" from="0 12 12" to="360 12 12" dur="1s" repeatCount="indefinite"/>
          </circle>
        </svg>
        <span>Loading...</span>
      </div>

      <!-- Error State -->
      <div *ngIf="hasError && !isLoading" class="dropdown-message error">
        <svg width="20" height="20" viewBox="0 0 20 20">
          <path d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm1 15H9v-2h2v2zm0-4H9V5h2v6z" fill="#dc3545"/>
        </svg>
        <span>Error loading results</span>
      </div>

      <!-- Empty State -->
      <div *ngIf="!isLoading && !hasError && filteredItems.length === 0" class="dropdown-message">
        <svg width="20" height="20" viewBox="0 0 20 20">
          <path d="M10 0C4.48 0 0 4.48 0 10s4.48 10 10 10 10-4.48 10-10S15.52 0 10 0zm1 15H9v-2h2v2zm0-4H9V5h2v6z" fill="#6C757D"/>
        </svg>
        <span>No results found</span>
      </div>

      <!-- Items List -->
      <div *ngIf="!isLoading && !hasError && filteredItems.length > 0" class="dropdown-items">
        <div
          *ngFor="let item of filteredItems; let i = index"
          class="dropdown-item"
          [class.highlighted]="i === highlightedIndex"
          [class.selected]="isItemSelected(item)"
          (click)="selectItem(item, $event)"
          (mouseenter)="highlightedIndex = i">
          
          <!-- Multi-select with checkbox -->
          <ng-container *ngIf="config.multiple">
            <div class="item-checkbox">
              <svg *ngIf="!isItemSelected(item)" class="checkbox-icon unchecked" width="18" height="18" viewBox="0 0 18 18">
                <rect x="1" y="1" width="16" height="16" rx="3" stroke="currentColor" stroke-width="2" fill="none"/>
              </svg>
              <svg *ngIf="isItemSelected(item)" class="checkbox-icon checked" width="18" height="18" viewBox="0 0 18 18">
                <rect x="1" y="1" width="16" height="16" rx="3" fill="#8749bd"/>
                <path d="M13.854 5.646a.5.5 0 0 1 0 .708l-5 5a.5.5 0 0 1-.708 0l-2.5-2.5a.5.5 0 1 1 .708-.708L8.5 10.293l4.646-4.647a.5.5 0 0 1 .708 0z" fill="white" stroke="white" stroke-width="0.5"/>
              </svg>
            </div>
          </ng-container>

          <!-- Custom Template -->
          <ng-container *ngIf="itemTemplate">
            <ng-container *ngTemplateOutlet="itemTemplate; context: { $implicit: item }"></ng-container>
          </ng-container>

          <!-- Default Template -->
          <ng-container *ngIf="!itemTemplate">
            <span class="item-text">{{ getDisplayValue(item) }}</span>
          </ng-container>

          <!-- Single-select check icon -->
          <svg *ngIf="!config.multiple && isItemSelected(item)" class="check-icon" width="16" height="16" viewBox="0 0 16 16">
            <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z" fill="currentColor"/>
          </svg>
        </div>
      </div>
    </div>
  </div>

  <!-- Error Message -->
  <div *ngIf="errorMessage" class="error-text">{{ errorMessage }}</div>
</div>
